import {
  CmsFooter,
  CmsHeader,
  CmsIconListItem,
  CmsMultiContent,
  CmsSeoSite,
} from '@domgen/dgx-fe-cms';

export interface CmsRegistrationRoot extends CmsHeader, CmsFooter, CmsSeoSite {
  applianceRegistrationBenefits: string[];
  registrationProtectionBenefits: CmsMultiContent<CmsIconListItem>;
}
